import { combineReducers } from "redux";
import domainReducer from "./domainReducer";
import filesReducer from "./filesReducer";
import sessionReducer from "./sessionReducer";
import accountReducer from "./accountReducer";
import queryReducer from "./queryReducer";
import snackbarReducer from "./snackbarReducer";
import pidReducer from "./pidReducer";

const rootReducer = combineReducers({
  domain: domainReducer,
  files: filesReducer,
  session: sessionReducer,
  account: accountReducer,
  query: queryReducer,
  pid: pidReducer,
  snackbar: snackbarReducer,
});

export default rootReducer;
